import { SignupCommunicationPreference } from "../types";

// Signing up is itself consent, so every option starts ticked in every country.
export const getPreselectedCommunicationPreferences = (newsletterForm: {
  communicationPreferences?: Array<{ id: string; label: string }>;
}): SignupCommunicationPreference[] =>
  (newsletterForm.communicationPreferences ?? []).map((option) => ({ value: option.id, label: option.label }));
